module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DropDown', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "isOpened": _vm.isOpened,
      "height": _vm.height
    },
    on: {
      "toggle": _vm.onToggle
    }
  }, [_c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.programs.length) ? _c('Carousel', _vm._l((_vm.programs), function(item, index) {
    return _c('SimpleCard', {
      key: index,
      staticClass: "separator",
      attrs: {
        "image": item.img && item.img.small,
        "title": item.title,
        "to": item.to,
        "favorite": _vm.saved(item),
        "carousel": true,
        "external": _vm.isExternal
      },
      on: {
        "toggle": function($event) {
          return _vm.toggle(item)
        }
      }
    })
  }), 1) : _vm._e(), (_vm.errors.length) ? _c('Errors', {
    attrs: {
      "errors": _vm.errors
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2a32dbc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/cabinet/components/block/Block.vue
// module id = 14d28ea524c67d7affb4
// module chunks = 19